module.exports = __webpack_public_path__ + "static/black-402fc8352af5f23043d02e4f06c5bab9.webp";